import { Clip } from '@/domains/asset';
import { getCaptions } from '@/libs/sharedAPI/common';
import { getSizeConfig } from '@/libs/sharedAPI/sizeConfig/SizeConfigFactory';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

export const updateClipConfig = (newClip: Clip) => {
  const shouldDeleteConfig = !!featureFlagStore.getSnapshot()[FeatureFlagKeys.Use_CL_Delete_Config];
  if (shouldDeleteConfig) {
    return;
  }

  const clipLayout = newClip.asset_metadata.layout;

  const useRemotionCaptions = clipLayout !== 'AUDIOGRAM';

  const sizeConfig = getSizeConfig(newClip.asset_metadata.size, newClip.id, newClip.asset_metadata.layout, 1);
  newClip.asset_metadata = {
    ...newClip.asset_metadata,
    config: {
      ...(newClip.asset_metadata.config || ({} as any)),
      captions: getCaptions(newClip.asset_metadata.introDuration || 0, sizeConfig, { ...newClip }),
      remotion_captions: useRemotionCaptions,
      filename: newClip.title
    }
  };
};
